export class SystemMessage {
  text: string;

  constructor(text: string) {
    this.text = text;
  }
}
